import { render, staticRenderFns } from "./ItemHistoryChangeTypeTexteditor.vue?vue&type=template&id=6f83f76b&scoped=true"
import script from "./ItemHistoryChangeTypeTexteditor.vue?vue&type=script&lang=js"
export * from "./ItemHistoryChangeTypeTexteditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f83f76b",
  null
  
)

export default component.exports